"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));
var _share = _interopRequireDefault(require("cccisd-icons/share3"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy4"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Component = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(args));
    _defineProperty(_this, "copyText", function (text) {
      (0, _copyToClipboard["default"])(text);
      (0, _cccisdNotification["default"])({
        message: 'Resource copied successfully!',
        type: 'success',
        duration: 8000
      });
    });
    return _this;
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        displayOptions = _this$props.displayOptions,
        name = _this$props.name,
        url = _this$props.url;
      var formatUrl = url ? url.replace(/\s/g, '%20') : '#';
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].icon,
          style: displayOptions.shareButtonColor ? {
            color: displayOptions.shareButtonColor
          } : {}
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "fs-4"
        }, /*#__PURE__*/_react["default"].createElement(_share["default"], null)), ' ', !displayOptions.showShareIconOnly && /*#__PURE__*/_react["default"].createElement("p", {
          className: "mb-0 mt-1"
        }, "Share")),
        title: 'Share resource for "' + name + '"',
        size: "large"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].shareRow
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].url
      }, url), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary btn-sm",
        onClick: function onClick() {
          return _this2.copyText(formatUrl);
        }
      }, /*#__PURE__*/_react["default"].createElement(_copy["default"], {
        spaceRight: true
      }), "Copy link")));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  name: _propTypes["default"].string,
  url: _propTypes["default"].string,
  displayOptions: _propTypes["default"].object.isRequired
});